import Papa from "papaparse";

export const convertCSVtoJSON = async buffer => {
	try {
		const { data } = Papa.parse(buffer, {
			header: true,
			skipEmptyLines: 'greedy'
		});

		return data
	}
	catch (err) {
		throw { err };
	}
}

export const convertJsonToCSV = async json => {
	try {
		const data = Papa.unparse(json);

		return data
	}
	catch (err) {
		throw { err };
	}
}

export const transformErrorMessage = async jserror => {
	return jserror.map((item, index) => {
		return {
			index,
			errors: item.map(x => {
				return {
					field: x.property,
					message: x.message
				}
			})
		}
	})
}

export const transformJSON = async (payload, schema) => {
	let nestedParam;
	for (let property in schema.properties) {
		if (schema.properties[property].type === "array") {
			nestedParam = property;
		}
	}
	const requiredTestParam = schema.required[0];
	if ((payload[0])[requiredTestParam] === "") {
		throw new Error('Invalid Data File');
	};
	let currentValidObject = 0;
	let nestedObject = [];
	let nestedJSONObject = {};
	nestedJSONObject = payload[0];
	let firstNestedDataObject = payload[0][nestedParam];
	nestedJSONObject[nestedParam] = [firstNestedDataObject];
	payload = payload.slice(1);
	payload.forEach((item, index) => {
		if (item[requiredTestParam] === "") {
			nestedJSONObject[nestedParam].push(item[nestedParam]);
			if (index === payload.length - 1) {
				nestedObject.push(nestedJSONObject);
			}
		}
		else {
			currentValidObject = index;
			nestedObject.push(nestedJSONObject);
			nestedJSONObject = item;
			firstNestedDataObject = item[nestedParam];
			nestedJSONObject[nestedParam] = [firstNestedDataObject];
			if (index === payload.length - 1) {
				nestedObject.push(nestedJSONObject);
			}
		}
	});
	return nestedObject;
}
